
import * as React from 'react';
import './progressiveImage.css'
import { SkeletonImage } from 'src/share/components/SkeletonImage/SkeletonImage';
import { IconTooltip } from '../IconTooltip/IconTooltip';

export interface IProgressiveImageProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  id: string;
  preview?: string;
  height?: number;
  width?: number;
  status?: number;
  arachnid?: boolean;
  onRedirect?: () => void;
}

export interface IProgressiveImageState {
  src?: boolean;
  preview?: boolean;
}

export default class ProgressiveImage extends React.Component<IProgressiveImageProps, IProgressiveImageState> {
  constructor(props: IProgressiveImageProps) {
    super(props);
    this.state = {
    }
  }
  public render() {
    const { className, id, arachnid, preview, src, status, height, width, onRedirect } = this.props;
    return (
      <>
        {
          !this.state.preview && !this.state.src &&
          <SkeletonImage height={height} width={width} />
        }
        {
          preview &&
          <img
            onLoad={() => this.setState({ preview: true })}
            style={this.state.preview && !this.state.src ? {} : { display: 'none' }}
            className={`progressive-image thumbnail ${className}`}
            src={preview}
          />
        }
        {(this.state.preview || this.state.src) && (arachnid || (status || status === 2)) ?
          <IconTooltip
            id={id}
            icon={`${arachnid ? 'window-close' : status === 1 ? 'user-circle' : 'check-circle'}`}
            placement="top" autoHide={true}
            text={`${arachnid ? 'This is a child abuse photo' : status === 1 ? 'Face recognized in this photo' : 'Match found in this photo'}`}
          />
          : <></>}
        <img
          width={width}
          height={height}
          style={this.state.src ? {} : { display: 'none' }}
          onLoad={(): void => this.setState({ src: true })}
          className={`progressive-image ${className} ${!this.state.src && 'thumbnail'}`}
          src={src}
          onClick={onRedirect}
        />
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/share/components/ProgressiveImage/ProgressiveImage.tsx